/* global require console */
import Vue from "vue";

export default Vue.component("image-viewer-ruler", {
  props: [
    // The pixel size of the described object when in full zoom
    "objectSize",
    // Pixels per cm
    "resolution",
    // Current scale
    "currentScale"
  ],

  data() {
    return {
      // Height of the visible ruler (w/o the labels)
      visibleSize: NaN,
      // Useful class names
      classNames: {
        ruler: "c-image-viewer-ruler",
        ticks: "c-image-viewer-ruler__ticks",
        tick: "c-image-viewer-ruler__tick",
        label: "c-image-viewer-ruler__label",
        labelTop: "c-image-viewer-ruler__label--top",
        labelBottom: "c-image-viewer-ruler__label--bottom"
      }
    };
  },

  computed: {
    // Amount of ticks (mm) to render based on full scales
    totalTicks() {
      return 1000;
    },

    // The tick model objects
    ticks() {
      return [...Array(this.totalTicks)].map((e, i) => {
        // Get modulo-ed index
        const mod = i % 10;
        return {
          // Index
          i,
          // Tick type
          type: mod == 9 ? "cm" : mod == 4 ? "half-cm" : "mm"
        };
      });
    },

    // mm in pixels for the current scale
    tickSize() {
      return (this.resolution / this.currentScale) / 10;
    },

    // Size of visible ruler in CM
    rulerSizeInCM() {
      return this.visibleSize * this.currentScale / this.resolution;
    }
  },

  methods: {
    getTickClassObject(tick) {
      return {
        [this.classNames.tick]: true,
        [`${ this.classNames.tick }--${ tick.type }`]: true,
        // Hide mm ticks if they are too dense
        [`${ this.classNames.tick }--hidden`]: tick.type == "mm" && this.tickSize < 4,
      };
    },

    getTickStyleObject() {
      return {
        "margin-top": (this.tickSize - 1) + "px"
      };
    }
  },

  mounted() {
    // Update once element is available.
    // TODO: handle resize
    this.visibleSize =
      this.$el.querySelector(`.${ this.classNames.ticks }`).clientHeight;
  },

  template: require("./templates/image-viewer-ruler.html")
});



// WEBPACK FOOTER //
// ./src/frontend/common/image-viewer/image-viewer-ruler.js